import { CloseCircleFilled, CloseOutlined } from '@ant-design/icons';
import { useTranslation } from '@framework/i18n';
import { Alert, AlertProps, Space } from 'antd';
import styled from 'styled-components';
import { LeafError } from '../LeafError';
import { ErrorsList } from './ErrorsList';

const StyledAlert = styled(Alert)`
  margin-bottom: 24px;

  .ant-alert-close-icon {
    &:focus-visible {
      outline: 2px solid ${props => props.theme.focusOutlineColor};
      outline-offset: 5px;
      border-radius: ${props => props.theme.borderRadius}px;
    }
  }
`;

const AlertIconSpan = styled.div`
  color: ${props => props.theme.colorError};
  font-size: 24px;
  height: 24px;
  line-height: 24px;
`;
const DescriptionContainer = styled.div`
  margin-left: 36px;
`;

export interface AlertMessageProps extends Omit<AlertProps, 'description'> {
  errors?: LeafError[] | undefined;
}

/**
 * Messaggio di errore
 */
export function AlertMessage(props: AlertMessageProps) {
  const { errors, ...otherProps } = props;
  const { t } = useTranslation();

  if (!errors || errors.length === 0) return null;

  return (
    <StyledAlert
      message={
        <Space size={12}>
          <AlertIconSpan>
            <CloseCircleFilled aria-label="Errore" aria-hidden />
          </AlertIconSpan>
          <span>
            {t(
              'form.alert-message.content',
              'Sono presenti errori di compilazione ({{errors_count}})',
              { errors_count: errors.length },
            )}
          </span>
        </Space>
      }
      // showIcon
      closable
      closeIcon={
        <CloseOutlined
          aria-label={t('alert-message.error.close-icon-label', 'Chiudi')}
        />
      }
      description={
        <DescriptionContainer>
          <ErrorsList errors={errors} />
        </DescriptionContainer>
      }
      type="error"
      {...otherProps}
    />
  );
}
